import React, {
  useState,
  useEffect,
  useContext,
  cloneElement,
  useMemo,
} from "react";
import api from "../../../services/api";
import AuthContext from "../../../contexts/Auth";
import EmpresaContext from "../../../contexts/Empresa";

import Assinatura from "./Assinatura";
import Checagem from "./Checagem";
import Colaborador from "./Colaborador";
import Hitorico from "./Historico";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
  UncontrolledDropdown,
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import OportunidadeSimplificada from "./OportunidadeSimplificada";
import GerarLinkQRCode from "./GerarLinkQRCode";
import moment from "moment";
import ListaIndicacoes from "../ProgramaDeIndicacao/ListaIndicacoes";
import Vendas from "../../proto/Vendas";
import { TipoEventoBtn } from "./styles";
import CustomCalendar from "../../../components/FullCalendar";

const actionComponentHandler = {
  vincular_oportunidade_proposta_concessionaria: (props) => {
    return <Vendas {...props} />;
  },
};

export default (
  {
    oportunidade,
    anuncio,
    handleChangeEstagio,
    handlePoliticaAssinada,
    onChangeMotivoEncerramento,
    onColaboradorChanged,
    notify,
    history,
    currentdataAgendamento,
    onComentarioSalvo,
  },
  ...props
) => {
  const { empresaSelecionada, parametrosEmpresa } = useContext(EmpresaContext);
  const { hasPermission } = useContext(AuthContext);
  const [estagio, setEstagio] = useState({});
  const [alert, setAlert] = useState(null);

  const [alertCrossSelling, setAlertCrossSelling] = useState(null);

  const [showHistorico, setShowHistorico] = useState(false);
  const [showOportunidadeSimplificada, setShowOportunidadeSimplicada] =
    useState(false);
  const [showGerarLinkQRCode, setShowGerarLinkQRCode] = useState(false);
  const [showListarIndicacoes, setShowListarIndicacoes] = useState(false);

  const [estagios, setEstagios] = useState([]);
  const [tiposAgendamentos, setTiposAgendamentos] = useState([]);
  const [tipoAgendamentoSelecionado, setTipoAgendamentoSelecionado] =
    useState(null);

  // const [acoesInteligentes, setAcoesInteligentes] = useState([]);
  const [currentAction, setCurrentAction] = useState("");
  const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const parametroComentario = parametrosEmpresa?.avancar_oportunidade_comentario === "true";
  const [showAlertEstagio, setShowAlertEstagio] = useState(false);
  const [comentarioEstagio, setComentarioEstagio] = useState("");
  const [pendingEstagio, setPendingEstagio] = useState(null);
  const [pendingAcoes, setPendingAcoes] = useState([]);

  const toggle = () => setModal(!modal);

  const openCalendarModal = (tipoAgendamento) => {
    setTipoAgendamentoSelecionado(tipoAgendamento);
    setIsCalendarModalOpen(true);
  };

  const closeCalendarModal = () => {
    setTipoAgendamentoSelecionado(null);
    setIsCalendarModalOpen(false);
  };

  useEffect(() => {
    if (estagios.length === 0) {
      loadEstagios();
    }
  }, []);

  useEffect(() => {
    loadEstagios();
  }, [anuncio]);

  useEffect(() => {
    if (oportunidade.id && oportunidade.estagio_id != estagio.id) {
      setEstagio(oportunidade.estagio);
      loadTiposAgendamentos();
    }
  }, [oportunidade]);

  const tiposAgendamentosFavoritos = useMemo(
    () => tiposAgendamentos.filter((tipo) => tipo.favorito),
    [tiposAgendamentos]
  );
  const tiposAgendamentosDemais = useMemo(
    () => tiposAgendamentos.filter((tipo) => !tipo.favorito),
    [tiposAgendamentos]
  );

  async function loadEstagios() {
    try {
      var urlGetEstagios = "";

      if (isNew()) {
        //altera para buscar pelos estágios do funil padrão da empresa

        if (anuncio && anuncio > 0) {
          urlGetEstagios = `/common/empresas/${empresaSelecionada?.id}/funilpadraoanuncio/${anuncio}`;
        } else {
          urlGetEstagios = `/common/empresas/${empresaSelecionada?.id}/funilpadraoempresa`;
        }
      } else {
        //alterar para busca por estágios do funil da oportunidade
        //urlGetEstagios = `/common/empresas/${empresaSelecionada?.id}/estagios`;
        if (oportunidade && oportunidade.id > 0 && oportunidade.funil_id > 0) {
          urlGetEstagios = `/common/empresas/${empresaSelecionada?.id}/funis/${oportunidade?.funil_id}/estagios`;
        } else {
          if (anuncio && anuncio > 0) {
            urlGetEstagios = `/common/empresas/${empresaSelecionada?.id}/funilpadraoanuncio/${anuncio}`;
          }
        }
      }

      //console.log(urlGetEstagios)

      const response = await api.get(urlGetEstagios);
      setEstagios(await response.data);

      if (!isNew() && response.data.length > 0) {
        if (!estagio || !estagio.id) {
          setEstagio(estagio[0]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const confirmAlertUpdateFase = (
    title,
    msg,
    confirmFunction,
    confirmButtonLabel = "Ok",
    confirmButtonColor = "primary"
  ) => {
    setAlert(
      <ReactBSAlert
        warning
        closeOnClickOutside={false}
        title={title}
        onCancel={() => setAlert(null)}
        onConfirm={confirmFunction}
        showCancel
        confirmBtnColor={confirmButtonColor}
        confirmBtnText={confirmButtonLabel}
        cancelBtnText="Cancelar"
        btnSize=""
      >
        {msg}
      </ReactBSAlert>
    );
  };

  const confirmAlertCrossSelling = (
    title,
    msg,
    confirmFunction,
    confirmButtonLabel = "Ok",
    confirmButtonColor = "primary"
  ) => {
    setAlertCrossSelling(
      <ReactBSAlert
        warning
        closeOnClickOutside={false}
        title={title}
        onCancel={() => setAlertCrossSelling(null)}
        onConfirm={confirmFunction}
        showCancel
        confirmBtnColor={confirmButtonColor}
        confirmBtnText={confirmButtonLabel}
        cancelBtnText="Não"
        btnSize=""
      >
        {msg}
      </ReactBSAlert>
    );
  };

  async function getAcoesInteligentes(estagioId) {
    const { data } = await api.get(
      `marketing/funis/${oportunidade.funil_id}/estagios/${estagioId}`
    );
    const actions = data
      .map((item) => item.acoesInteligentes.map((e) => e.key))
      .flatMap((num) => num);
    return actions;
  }

  async function onChangeEstagio(proximoEstagio) {
    let acoesInteligentes = [];
    try {
      acoesInteligentes = await getAcoesInteligentes(
        proximoEstagio.estagio_id
      );
    } catch (error) {
      console.log("Erro ao buscar ações inteligentes:", error);
    }

    if (!isNew()) {
      setPendingEstagio(proximoEstagio);
      setPendingAcoes(acoesInteligentes);
      setComentarioEstagio("");
      setShowAlertEstagio(true);
    }
  }
  function goToPrint(id) {
    history.push(`/admin/oportunidades/${new Number(id)}/print`);
  }

  const successAlert = (msg) => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-250px", maxWidth: "500px" }}
        title={msg}
        confirmBtnBsStyle="success"
        showConfirm={false}
        btnSize=""
      />
    );
    setTimeout(() => setAlert(null), 2000);
  };

  function onChangeEstagioToVenda() {
    if (!isNew()) {
      confirmAlertCrossSelling(
        "Criar Cross-Selling",
        <>
          Deseja criar uma nova oportunidade a partir dos produtos declinados
          desta oportunidade encerrada?
        </>,
        () => criarNovaOportunidadeCrossSelling(),
        "Sim"
      );
    }
  }

  function goToNewCrossSelling() {
    history.push("/admin/oportunidades/new", {
      oportunidadeToCrossSelling: oportunidade.id,
      tipoCrossSelling: "produtos_declinados",
    });
  }

  async function criarNovaOportunidadeCrossSelling() {
    try {
      //volta pra tela de oportunidades, e logo após abre a tela Nova oportunidade carregando os dados
      //de cliente, produtos declinados e espectativa da oportunidade encerrada como venda.
      setTimeout(history.goBack, 200);
      setTimeout(goToNewCrossSelling, 500);
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível abrir nova oportunidade");
    }
  }

  async function validateActions(nextEstagio, acoesInteligentes, comentario = "") {
    const exists = acoesInteligentes.some((item) =>
      Object.keys(actionComponentHandler).includes(item)
    );

    if (acoesInteligentes.length && exists) {
      for (const action of acoesInteligentes) {
        setCurrentAction(
          actionComponentHandler[action]({
            oportunidade: oportunidade,
            callback: () => changeToEstagio(nextEstagio, comentario),
          })
        );
        setModal(true);
      }
    } else {
      changeToEstagio(nextEstagio, comentario);
    }
  }

  async function changeToEstagio(nextEstagio, comentario = "") {
    try {
      let response;
      if (nextEstagio.flag_conversao) {
        // Se a fase destino é a de conversão, aciona a rota de conversão
        response = await api.put(
          `/marketing/oportunidades/${oportunidade.id}/converter`,
          {
            user_id: empresaSelecionada?.id,
          }
        );
      } else {
        // Comportamento normal de avanço de fase
        response = await api.put(
          `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidade.id}/avancar-oportunidades`,
          {
            estagio_id: nextEstagio.id,
            data_agendamento: currentdataAgendamento,
          }
        );
      }

      if (comentario.trim()) {
        try {
          await api.post(
            `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidade.id}/comentarios`,
            { descricao: comentario }
          );
          if (onComentarioSalvo) onComentarioSalvo();
        } catch (comentarioError) {
          console.log(comentarioError);
          if (notify) notify("danger", "Estágio alterado, mas não foi possível salvar o comentário.");
        }
      }
      
      const data = await response.data;
      const data_encerramento = await data.data_encerramento;
      const motivoEncerramento = await data.motivoEncerramento;
      setEstagio(nextEstagio);
      if (onChangeMotivoEncerramento && data_encerramento && motivoEncerramento)
        onChangeMotivoEncerramento(motivoEncerramento);
      if (handleChangeEstagio) {
        handleChangeEstagio(estagio);
      }
      successAlert("Estágio alterado");
      setModal(false);
      if (nextEstagio && nextEstagio.id == 3) {
        var valid = await thisOportunidadeContemProdutosDeclinados();
        if (valid) {
          onChangeEstagioToVenda();
        }
      }
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível alterar estagio");
    }
  }

  async function loadTiposAgendamentos() {
    try {
      const { data } = await api.get(`marketing/tipos-agendamentos-empresas`);

      const tiposAgendamentosEmpresa = data.map((tae) => ({
        ...tae.tipoAgendamento,
        favorito: tae.favorito,
      }));

      setTiposAgendamentos(tiposAgendamentosEmpresa);
    } catch (error) {
      console.log(error);
    }
  }

  async function thisOportunidadeContemProdutosDeclinados() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidade.id}/produtos_declinados`
      );
      var prodDeclidados = response.data;
      var hasProdutosDeclinados = prodDeclidados && prodDeclidados.length > 0;
      return hasProdutosDeclinados;
    } catch (error) {
      notify("danger", "Não foi possivel carregar produtos declinados");
      return false;
    }
  }

  function isNew() {
    return !(oportunidade && oportunidade.id);
  }

  function handleHiddeHistorico() {
    setShowHistorico(false);
  }

  function canShowHistorico() {
    return !isNew() && hasPermission("ver-todas-oportunidades");
  }

  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: "1200px" }}
        backdrop="static"
      >
        <ModalBody>{currentAction}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>

      {showAlertEstagio && (
        <ReactBSAlert
          warning
          style={{ marginTop: 0, transform: "translateY(-50%)" }}
          closeOnClickOutside={false}
          title="Alterar estágio"
          onCancel={() => setShowAlertEstagio(false)}
          onConfirm={() => {
            setShowAlertEstagio(false);
            validateActions(pendingEstagio, pendingAcoes, comentarioEstagio);
          }}
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Cancelar"
          disabled={parametroComentario && comentarioEstagio.trim().length < 15}
          btnSize=""
        >
          <>
            <p>
              Deseja realmente alterar o estágio dessa oportunidade para{" "}
              <strong>{pendingEstagio?.nome}</strong>? <br />
              <br />
              Verifique a data de agendamento <br />
              <strong>
                {moment(currentdataAgendamento).format("DD/MM/YYYY HH:mm")}
              </strong>
            </p>
            {parametroComentario && (
              <FormGroup>
                <Label>
                  Comentário <span className="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  rows={3}
                  placeholder="Adicione um comentário para avançar o estágio"
                  value={comentarioEstagio}
                  onChange={(e) => setComentarioEstagio(e.target.value)}
                />
                {comentarioEstagio.trim().length === 0 && (
                  <small className="text-muted">
                    O comentário é obrigatório para avançar o estágio.
                  </small>
                )}
                {comentarioEstagio.trim().length > 0 && comentarioEstagio.trim().length < 15 && (
                  <small className="text-danger">
                    O comentário deve ter pelo menos 15 caracteres ({comentarioEstagio.trim().length}/15)
                  </small>
                )}
              </FormGroup>
            )}
          </>
        </ReactBSAlert>
      )}

      {alert}
      {alertCrossSelling}
      {canShowHistorico() && (
        <Hitorico
          notify={notify}
          show={showHistorico}
          onHidde={handleHiddeHistorico}
          oportunidade_id={oportunidade.id}
        />
      )}
      <h1 className="d-flex" style={{ justifyContent: "space-between" }}>
        {isNew() ? (
          <span>Nova Oportunidade</span>
        ) : (
          <span>Alterar Oportunidade</span>
        )}

        <div className="d-flex align-items-center justify-items-center ">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {!oportunidade.data_encerramento && (
              <>
                <Colaborador
                  oportunidade={oportunidade}
                  notify={notify}
                  onColaboradorChanged={onColaboradorChanged}
                />
              </>
            )}
            {!isNew() ? (
              //   <Button
              //     size="sm"
              //     style={{
              //       padding: 6,
              //     }}
              //     color="primary"
              //     title="Programa de indicação"
              //     onClick={() => setShowOportunidadeSimplicada(true)}
              //   >
              //     <span className="btn-inner--icon">
              //       <i className="ni ni-fat-add"></i>
              //     </span>
              //     <span className="btn-inner--text">Programa de Indicação</span>
              //   </Button>
              <UncontrolledDropdown
                style={{
                  paddingRight: 4,
                }}
                group
                size="sm"
                direction="down"
              >
                <DropdownToggle
                  caret
                  //   disabled={isNew() || oportunidade.data_encerramento}
                  color={"primary"}
                >
                  {" "}
                  Programa de Indicação
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem
                    onClick={() => setShowOportunidadeSimplicada(true)}
                  >
                    Registrar
                  </DropdownItem>
                  <DropdownItem onClick={() => setShowGerarLinkQRCode(true)}>
                    Gerar Link
                  </DropdownItem>
                  <DropdownItem onClick={() => setShowListarIndicacoes(true)}>
                    Listar indicações
                  </DropdownItem>
                </DropdownMenu>
                <Button
                  color="primary"
                  onClick={() => {
                    goToPrint(oportunidade.id);
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                    margin: "0",
                  }}
                >
                  <i className="fas fa-print" style={{ color: "#0847d6" }}></i>
                </Button>
              </UncontrolledDropdown>
            ) : null}

            <OportunidadeSimplificada
              isOpen={showOportunidadeSimplificada}
              clienteIndicadorId={oportunidade.cliente_id}
              data={oportunidade}
              hideModal={() => setShowOportunidadeSimplicada(false)}
            />
            <GerarLinkQRCode
              isOpen={showGerarLinkQRCode}
              clienteIndicadorId={oportunidade.cliente_id}
              data={oportunidade}
              hideModal={() => setShowGerarLinkQRCode(false)}
              notify={notify}
            />
            {showListarIndicacoes && (
              <ListaIndicacoes
                isOpen={showListarIndicacoes}
                clienteIndicadorId={oportunidade.cliente_id}
                hideModal={() => setShowListarIndicacoes(false)}
                history={history}
              />
            )}

            {!oportunidade.data_encerramento && (
              <>
                <Checagem
                  oportunidade={oportunidade}
                  notify={notify}
                  onChecado={handleChangeEstagio}
                />
                <Assinatura
                  oportunidade={oportunidade}
                  notify={notify}
                  onAssinado={handlePoliticaAssinada}
                />
              </>
            )}
          </div>

          {hasPermission("ver-todas-oportunidades") && (
            <Button
              style={{
                padding: 6,
              }}
              color="link"
              title="Histórico"
              onClick={() => setShowHistorico(true)}
            >
              <i class="far fa-clock"></i>
            </Button>
          )}
        </div>
      </h1>

      {!isNew() && (
        <ButtonGroup
          className="w-100 py-4 flex-wrap"
          style={{ fontSize: "14px", rowGap: "1rem" }}
        >
          <UncontrolledDropdown
            group
            direction="down"
            style={{ flex: "1", minWidth: "210px", maxWidth: "20%" }}
          >
            <DropdownToggle
              disabled={isNew() || oportunidade.data_encerramento}
              className="text-right pr-2 mr-2 font-weight-bold rounded"
              color={
                isNew() || estagio?.cor?.includes("#")
                  ? "primary"
                  : estagio?.cor
              }
              style={{
                width: "100%",
                background: estagio?.cor?.includes("#")
                  ? estagio?.cor
                  : "#172b4d",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: ".75rem",
                paddingLeft: "8px",
                flex: 1,
                border: 0,
              }}
            >
              <div
                className="d-flex flex-column text-left"
                style={{ gap: "4px" }}
              >
                <small>Estágio</small>
                <span>
                  {isNew()
                    ? estagios.length > 0
                      ? estagios[0].nome
                      : ""
                    : estagio?.nome}
                </span>
              </div>

              <span
                style={{
                  marginLeft: "8px",
                  border: "2px solid white",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "inline-block",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fas fa-filter"></i>
              </span>
            </DropdownToggle>
            <DropdownMenu right>
              {!isNew() &&
                estagios.length > 0 &&
                estagios.map((item, key) => {
                  if (item.id === estagio?.id) return null;
                  return (
                    <DropdownItem
                      key={key}
                      onClick={(e) => {
                        e.preventDefault();
                        onChangeEstagio(item);
                      }}
                    >
                      {item.nome}
                    </DropdownItem>
                  );
                })}
            </DropdownMenu>
          </UncontrolledDropdown>
          {tiposAgendamentosFavoritos?.map((tipoAgendamento) => (
            <TipoEventoBtn
              key={tipoAgendamento.id}
              onClick={() => openCalendarModal(tipoAgendamento)}
            >
              <span>
                <i className={`${tipoAgendamento.icon} mr-2`}></i>
              </span>
              {tipoAgendamento.nome}
            </TipoEventoBtn>
          ))}
          <UncontrolledDropdown
            group
            direction="down"
            style={{ flex: "1", border: 0 }}
          >
            <DropdownToggle className="p-0 w-100">
              <TipoEventoBtn className="w-100">
                <span>
                  <i className="fas fa-plus mr-2"></i>
                </span>
                Mais opções
              </TipoEventoBtn>
            </DropdownToggle>
            <DropdownMenu right>
              {/* {tiposAgendamentosPersonalizados.length === 0 && "LALALA"} */}
              {tiposAgendamentosDemais.length > 0 &&
                tiposAgendamentosDemais.map((item, index) => (
                  <DropdownItem
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      openCalendarModal(item);
                    }}
                  >
                    {item.nome}
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
      )}

      <Modal
        isOpen={isCalendarModalOpen}
        toggle={closeCalendarModal}
        size="xl"
        style={{
          width: "100%",
          maxWidth: "70%",
          maxHeight: "80%",
        }}
      >
        <ModalBody className="p-0">
          <CustomCalendar
            oportunidadeId={oportunidade.id}
            tipoAgendamento={tipoAgendamentoSelecionado}
            nomeCliente={oportunidade.cliente?.nome}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={closeCalendarModal}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
